import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";

const ViewDetail = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");
 
  // const getStatus = (status) => {
  //   if (status === "SUCCESS") {
  //     return <Success>Success</Success>;
  //   } else {
     
  //     return <Failed>Failed</Failed>;
  //   }
    
  // };

  const getStatus = (status) => {
    if (status === 1) {
      return <Pending>Pending</Pending>;
    } else if (status === 2) {
      return <Completed>Completed</Completed>;
    } else if (status === 3) {
      return <Active>Active</Active>;
    } else if (status === 4) {
      return <Inactive>Inactive</Inactive>;
    } else if (status === 5) {
      return <Deleted>Deleted</Deleted>;
    } else {
      return 'Invalid Status';
    }
  };

  const getPolice = (isPoliceVerificationEnabled) => {
    if (isPoliceVerificationEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  // const getId = (isIdVerificationEnabled) => {
  //   if (isIdVerificationEnabled === 1) {
  //     return <p>Yes</p>;
  //   } else {
  //     return <p>No</p>;
  //   }
  // };

  const getGround = (isGroundIncluded) => {
    if (isGroundIncluded === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };
  const getRent = (isRentAgreementEnabled) => {
    if (isRentAgreementEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  const getProperty = (propId) => {
    if (propId) {
      return <PropertyId>#{propId}</PropertyId>;
    } else {
      return <p>N/A</p>;
    }
  };

  const getRentalBond = (bondPlan) => {
    if (bondPlan === 1) {
     return <p>Active</p>;
    } else if  (bondPlan === 2) {
      return <p>Inactive</p>;
    }else{
      return <p>N/A</p>;
    }
  };

  const getBondPaymnet = (isBondAvailable) => {
    if (isBondAvailable === 1) {
     return <p>Prepaid</p>;
    } else if  (isBondAvailable === 2) {
      return <p>Postpaid</p>;
    }else{
      return <p>N/A</p>;
    }
  };

  const getAgreement = (rentAgreementPath) => {
    if (rentAgreementPath) {
      return (
        <a
          href={selectedData.rentAgreementPath}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary-color text-sm"
        >
          Click Me
        </a>
      );
    }
  };

  const getSign = (signaturePath) => {
    if (signaturePath) {
      return (
        <a
          href={selectedData.signaturePath}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary-color text-sm"
        >
          Click Me
        </a>
      );
    }
  };

  // const getType = (type) => {
  //   if (type == 1) {
  //     return <p>PG</p>;
  //   } else {
  //     return <p>Flat</p>;
  //   }
  // };

  const getPreference = (tenantPreference) => {
    if (tenantPreference == 1) {
      return <p>Male</p>;
    } else if (tenantPreference == 2) {
      return <p>Female</p>;
    } else {
      return <p>Both</p>;
    }
  };

  const getid = (id) => {
    if (id) {
      return <PropertyId>#{id}</PropertyId>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };

  const getPropertyType = (type) => {
    if(type === 1 ){
       return <p>PG</p>
    }else if(type ===2){
      return <p>Flat</p>
    }
  }

  const getType = (type) =>{
   if(type === 1){
     return <p>No. of Floors</p>
   }else if(type ===2){
    return  <p>No. of Flat</p>
   }
  }
   
  const getGender = (tenantPreference) =>{
    if(tenantPreference === 1){
      return <p>Male</p>
    }else if(tenantPreference === 2){
     return  <p>Female</p>
    }else{
      return  <p>Both</p>
    }
   }
   const getRentalCycle = (rentalCycle) =>{
    if(rentalCycle === "01"){
      return <p>1st to 1st</p>
    }else if(rentalCycle === 15){
      return <p>15th to 15th</p>
    }else{
      return  <p>Move-In-Date</p>
    }
   }
  //  const getGracePeriod = (gracePeriod) =>{
  //   if(gracePeriod === 5){
  //     return <p>{gracePeriod} days</p>
  //   }else if(gracePeriod === 7){
  //     return  <p>{gracePeriod} days</p>
  //   }else if(gracePeriod === 10){
  //     return  <p>{gracePeriod} days</p>
  //   }else{

  //   }
  //   }

    
    const getFineAmount = (fine ) =>{
      if(fine === 0){
        return <p>₹{fine}</p>
      }else{
       return  <p>₹{fine}</p>
      }
      }

      const getFine = (fine ) =>{
        if(fine === 0){
          return <p>No</p>
        }else{
         return  <p>Yes</p>
        }
        }

      const getFineType = (fineType) =>{
        if(fineType === 1){
          return  <p>One Time</p> 
        }else if (fineType  === 2) {
         return  <p>Daily</p> 
        }
      }
      const getAgreementPeriod = (agreementPeriod) =>{
        if(agreementPeriod > 1){
          return  <p>{agreementPeriod} Months</p> 
        }else if (agreementPeriod  === 1) {
          return   <p>{agreementPeriod} Month</p> 
        }else{
          return  <p>N/A</p> 
        }
      }
      const getNoticePeriod= (noticePeriod) =>{
        if(noticePeriod > 1){
          return  <p>{noticePeriod} Months</p> 
        }else if (noticePeriod  === 1) {
          return   <p>{noticePeriod} Month</p> 
        }else{
          return  <p>N/A</p> 
        }
      }
      const getlockInPeriod = (lockInPeriod) =>{
        if(lockInPeriod > 1){
          return  <p>{lockInPeriod} Months</p> 
        }else if (lockInPeriod  === 1) {
          return   <p>{lockInPeriod} Month</p> 
        }else{
          return  <p>N/A</p> 
        }
      }
      const getGracePeriod = (gracePeriod) =>{
        if(gracePeriod > 1){
          return  <p>{gracePeriod} Days</p> 
        }else if (gracePeriod  === 1) {
          return   <p>{gracePeriod} Days</p> 
        }else{
          return  <p>N/A</p> 
        }
      }

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>{getid(selectedData?.id) || "N/A"}</Status>
          <Status className="ml-3">
            {getStatus(selectedData?.status) || "N/A"}
          </Status>
        </div>

        <Column>
          <FirstColumn>
          <SubHeading>Property Name</SubHeading>
          <Paragraph>{selectedData?.name || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>GID</SubHeading>
            <Paragraph>{selectedData?.gId || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("LL") || "N/A"}
            </Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Updated At</SubHeading>
            <Paragraph>
              {moment(selectedData?.updatedAt).format("LL") || "N/A"}
            </Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>
          <TemplateButton
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
           Tenant & Agreement Details
          </TemplateButton>

           <TemplateButton
            isActive={detailType === "3"}
            onClick={() => setDetailType("3")}
          >
            Rent Details
          </TemplateButton>
           
          {/* <TemplateButton
            isActive={detailType === "4"}
            onClick={() => setDetailType("4")}
          >
            Bond Setting
          </TemplateButton> */}
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
               <SingleItem
                name={"Owner"}
                value={selectedData?.ownerName || "N/A"}
              />
               <SingleItem
                name="Phone Number"
                value={selectedData?.ownerMobile || "N/A" }
              />
              <SingleItem
                name={"Address"}
                value={selectedData?.address|| "N/A"}
              />
              <SingleItem
                name={"Street Address"}
                value={selectedData?.streetAddress|| "N/A"}
              />
                <SingleItem
                name={"Property Type"}
                value={getPropertyType(selectedData?.type) || "N/A"}
              /> 
               <SingleItem
                name={getType(selectedData?.type)}
                value={selectedData?.floorCount || "0"}
              /> 
              {/* <SingleItem
                name={"Unit Number"}
                value={selectedData?.numberOfUnits}
              /> */}
            </>
          )}

          {detailType === "2" && (
            <>
              <SingleItem
                name="Gender"
                value={getGender(selectedData?.tenantPreference)|| "N/A"}
              />
              <SingleItem
                name="Security Deposit"
                value={selectedData?.security|| "N/A"}
              />
               <SingleItem
                name="Agreement Period"
                value={getAgreementPeriod(selectedData?.agreementPeriod)}
              />
               <SingleItem
                name="Notice Period"
                value={getNoticePeriod(selectedData?.noticePeriod)}
              />
               <SingleItem
                name="Lock-in-Period"
                value={getlockInPeriod(selectedData?.lockInPeriod)}
              />
            </>
          )}

           {detailType === "3" && (
            <>
              <SingleItem
                name="Rental Cycle"
                value={getRentalCycle(selectedData?.rentalCycle) || "N/A"}
              />
              <SingleItem
                name="Grace Period"
                value={getGracePeriod(selectedData?.gracePeriod )}
              />
                 <SingleItem
                name="Fine"
                value={getFine(selectedData?.fine )|| "N/A"}
              />
              
              {selectedData?.fine > 0   && (
           <>
              <SingleItem
                name="Fine Amount"
                value={getFineAmount(selectedData?.fine) || "N/A"}
              />
            <SingleItem
               name="Fine Type"
              value={getFineType(selectedData?.fineType) || "N/A"}
               />
              </>
    )}            
            </>
          )}

        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, selectedData }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <p>:</p>
    <Value>
      {(name === "Security"  || name === "Maintenance Fee") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      
      {/* {selectedData > 0 && (
        <>
          {(name === "Agreement Period" ||
            name === "Notice Period" ||
            name === "Lock-in-Period") && <span className="ml-1">months</span>}

          {name === "Grace Period" && <span className="ml-1">days</span>}
        </>
      )} */}
    </Value>
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest} // Spread the remaining props onto the button element
    >
      {rest.children}
    </button>
  );
};

const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 space-x-4`;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`flex flex-row gap-2 text-lg md:text-xl text-gray-700 font-bold text-left`;
const Name = tw.p`text-sm text-gray-500  w-32`;
const Value = tw.p`text-sm text-black font-medium w-80 px-6 `;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Active = tw.div`bg-emerald-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Pending = tw.div`bg-blue-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Completed = tw.div`bg-purple-600 text-white text-xs inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Inactive = tw.div`bg-yellow-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Unverified = tw.div`border border-rose-600 text-rose-600 text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Deleted = tw.div`bg-rose-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
export default ViewDetail;
